import { render, staticRenderFns } from "./venimport.vue?vue&type=template&id=f138a7e0&scoped=true&"
import script from "./venimport.vue?vue&type=script&lang=js&"
export * from "./venimport.vue?vue&type=script&lang=js&"
import style0 from "./venimport.vue?vue&type=style&index=0&id=f138a7e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f138a7e0",
  null
  
)

export default component.exports